import * as React from 'react'

const SvgStopFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 4.5H6A1.5 1.5 0 004.5 6v12A1.5 1.5 0 006 19.5h12a1.5 1.5 0 001.5-1.5V6A1.5 1.5 0 0018 4.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgStopFilledIcon
